
import Footer from 'components/Footer'
import React, { useEffect } from 'react'

const PrivPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const headingFont = "'General Sans', sans-serif";
    const bodyFont = "'Manrope', sans-serif";

    const sectionTitleStyle = {
        marginTop: '40px',
        marginBottom: '15px',
        fontFamily: headingFont,
        fontSize: '28px',
        fontWeight: 'bold',
        color: '#333',
        textTransform: 'uppercase'
    };

    const subSectionTitleStyle = {
        marginTop: '25px',
        marginBottom: '10px',
        fontFamily: headingFont,
        fontSize: '20px',
        fontWeight: '600',
        color: '#444'
    };

    const subLabelStyle = {
        marginTop: '15px',
        marginBottom: '6px',
        fontFamily: headingFont,
        fontSize: '16px',
        fontWeight: '600',
        color: '#555'
    };

    const paragraphStyle = {
        textAlign: 'justify',
        marginTop: '10px',
        fontFamily: bodyFont,
        lineHeight: '1.8',
        color: '#555',
        fontSize: '16px'
    };

    const listStyle = {
        paddingLeft: '25px',
        paddingTop: '10px',
        fontFamily: bodyFont,
        color: '#555',
        lineHeight: '1.8',
        fontSize: '16px',
        listStyleType: 'disc'
    };

    const importantBoxStyle = {
        backgroundColor: '#FFF9C4',
        borderLeft: '4px solid #FBC02D',
        borderRadius: '6px',
        padding: '14px 18px',
        marginTop: '14px',
        marginBottom: '10px',
        fontFamily: bodyFont,
        fontSize: '15px',
        color: '#555',
        lineHeight: '1.7'
    };

    return (
        <>
            <div style={{ width: '100%' }}>
                {/* Banner */}
                <div className="bannerImage" style={{ width: '100%', height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#6b5fe4' }}>
                    <h1 style={{ textAlign: 'center', fontSize: '50px', color: 'white', fontFamily: headingFont }}>Privacy Policy</h1>
                </div>

                <div style={{ width: '85%', margin: 'auto', paddingBottom: '100px' }}>
                    <h2 style={{ marginTop: '50px', fontFamily: headingFont, fontSize: '36px' }}><strong>WASHTA PRIVACY POLICY</strong></h2>
                    <p style={paragraphStyle}>
                        <strong>Effective Date:</strong> March 17, 2026 &nbsp;|&nbsp; <strong>Last Updated:</strong> March 17, 2026 &nbsp;|&nbsp; <strong>Version:</strong> 1.0
                    </p>

                    {/* ── 1. DATA CONTROLLER INFORMATION ── */}
                    <h3 style={sectionTitleStyle}>1. Data Controller Information</h3>
                    <p style={paragraphStyle}>
                        This Privacy Policy describes how Washta collects, uses, shares, and protects your personal data in compliance with the UAE Federal Decree-Law No. 45 of 2021 on the Protection of Personal Data (the "UAE PDPL").
                    </p>
                    <ul style={listStyle}>
                        <li><strong>Legal Entity:</strong> SNR LLC</li>
                        <li><strong>Commercial Registration:</strong> 2429317.01</li>
                        <li><strong>Registered Address:</strong> Sharjah Media City, Sharjah, UAE</li>
                        <li><strong>Contact Email:</strong> info@washta.com</li>
                        <li><strong>Data Protection Officer:</strong> info@washta.com</li>
                    </ul>
                    <p style={paragraphStyle}>
                        The "Platform" refers to the Washta mobile application, website, and all related services provided by Washta.
                    </p>

                    {/* ── 2. SCOPE AND ACCEPTANCE ── */}
                    <h3 style={sectionTitleStyle}>2. Scope and Acceptance</h3>
                    <p style={paragraphStyle}>This Privacy Policy applies to all users of the Washta Platform, including:</p>
                    <ul style={listStyle}>
                        <li>Customers who book services through the Platform.</li>
                        <li>Visitors who browse the Platform without booking services.</li>
                    </ul>
                    <p style={paragraphStyle}>
                        By accessing or using the Platform, you acknowledge that you have read, understood, and agree to be bound by this Privacy Policy. If you do not agree, please discontinue use of the Platform immediately.
                    </p>

                    {/* ── 3. INFORMATION WE COLLECT ── */}
                    <h3 style={sectionTitleStyle}>3. Information We Collect</h3>
                    <p style={paragraphStyle}>We collect personal data necessary to provide our services. The categories of data we collect include:</p>

                    <h4 style={subSectionTitleStyle}>3.1 Information You Provide Directly</h4>
                    <p style={subLabelStyle}>Account Registration and Booking Information:</p>
                    <ul style={listStyle}>
                        <li>Full name</li>
                        <li>Phone number</li>
                        <li>Email address</li>
                        <li>Vehicle information (plate number, make, model, color)</li>
                        <li>Service location address (where service will be performed)</li>
                    </ul>
                    <p style={subLabelStyle}>Communications:</p>
                    <ul style={listStyle}>
                        <li>Messages, feedback, or inquiries you send to us or Service Providers through the Platform.</li>
                        <li>Customer service interactions and support tickets.</li>
                    </ul>

                    <h4 style={subSectionTitleStyle}>3.2 Information Collected Automatically</h4>
                    <p style={subLabelStyle}>Device and Technical Information:</p>
                    <ul style={listStyle}>
                        <li>IP address and device identifiers</li>
                        <li>Browser type and version</li>
                        <li>Operating system and device type</li>
                        <li>Mobile network information</li>
                        <li>Time zone settings and language preferences</li>
                    </ul>
                    <p style={subLabelStyle}>Location Data:</p>
                    <p style={paragraphStyle}>
                        With your explicit consent, we collect precise location data (GPS coordinates) when you search for nearby service providers, enter a service location for booking, or use location-based features of the Platform. You may withdraw location permissions at any time through your device settings, though this may limit certain Platform functionality.
                    </p>
                    <p style={subLabelStyle}>Usage and Analytics Data:</p>
                    <ul style={listStyle}>
                        <li>Pages viewed, features accessed, and navigation patterns</li>
                        <li>Search queries and filters applied</li>
                        <li>Date and time of Platform access</li>
                        <li>Referral sources (how you arrived at the Platform)</li>
                        <li>Error logs and performance data</li>
                    </ul>

                    <h4 style={subSectionTitleStyle}>3.3 Transaction and Booking Data</h4>
                    <ul style={listStyle}>
                        <li>Booking history (dates, services requested, Service Providers selected)</li>
                        <li>Service completion status and ratings/reviews</li>
                        <li>Payment transaction confirmations and invoice data</li>
                        <li>Payment method type (e.g., credit card, digital wallet)</li>
                    </ul>
                    <div style={importantBoxStyle}>
                        <strong>Important:</strong> Washta does NOT store full credit/debit card numbers, CVV codes, or complete payment card details. All payment processing is handled by certified third-party payment processors in compliance with PCI DSS standards.
                    </div>

                    <h4 style={subSectionTitleStyle}>3.4 Information from Third Parties</h4>
                    <p style={paragraphStyle}>We may receive limited information from:</p>
                    <ul style={listStyle}>
                        <li><strong>Service Providers:</strong> Updates on service completion status, customer feedback provided directly to them.</li>
                        <li><strong>Payment Processors:</strong> Transaction confirmation, payment status.</li>
                        <li><strong>Analytics Providers:</strong> Aggregated, anonymized usage trends (e.g., Google Analytics).</li>
                    </ul>

                    {/* ── 4. LEGAL BASIS FOR PROCESSING ── */}
                    <h3 style={sectionTitleStyle}>4. Legal Basis for Processing</h3>
                    <p style={paragraphStyle}>Under the UAE PDPL, we process your personal data based on the following lawful grounds:</p>
                    <ul style={listStyle}>
                        <li><strong>Contract Performance:</strong> To facilitate bookings, connect you with Service Providers, process payments, and deliver services you request.</li>
                        <li><strong>Consent:</strong> Marketing communications, location data collection, optional features, cookies (non-essential).</li>
                        <li><strong>Legitimate Interest:</strong> Platform improvement, fraud prevention, security, dispute resolution, analytics.</li>
                        <li><strong>Legal Obligation:</strong> Compliance with UAE tax laws, accounting requirements, law enforcement requests, and regulatory obligations.</li>
                    </ul>

                    {/* ── 5. HOW WE USE YOUR INFORMATION ── */}
                    <h3 style={sectionTitleStyle}>5. How We Use Your Information</h3>
                    <p style={paragraphStyle}>We use your personal data for the following purposes:</p>

                    <h4 style={subSectionTitleStyle}>5.1 Service Delivery</h4>
                    <ul style={listStyle}>
                        <li>Facilitate and manage service bookings.</li>
                        <li>Connect you with appropriate Service Providers based on location, availability, and service type.</li>
                        <li>Send booking confirmations, reminders, and status updates.</li>
                        <li>Enable communication between you and Service Providers for service coordination.</li>
                    </ul>

                    <h4 style={subSectionTitleStyle}>5.2 Payment Processing</h4>
                    <ul style={listStyle}>
                        <li>Process payments and issue invoices.</li>
                        <li>Detect and prevent payment fraud.</li>
                        <li>Maintain transaction records for accounting and tax purposes.</li>
                    </ul>

                    <h4 style={subSectionTitleStyle}>5.3 Platform Improvement and Analytics</h4>
                    <ul style={listStyle}>
                        <li>Analyze usage patterns to improve user experience and functionality.</li>
                        <li>Conduct research and development for new features.</li>
                        <li>Generate aggregated, anonymized statistics on Platform performance.</li>
                        <li>Optimize Service Provider matching algorithms.</li>
                    </ul>

                    <h4 style={subSectionTitleStyle}>5.4 Customer Support</h4>
                    <ul style={listStyle}>
                        <li>Respond to inquiries, complaints, and support requests.</li>
                        <li>Investigate and resolve disputes between customers and Service Providers.</li>
                        <li>Provide technical assistance.</li>
                    </ul>

                    <h4 style={subSectionTitleStyle}>5.5 Security and Fraud Prevention</h4>
                    <ul style={listStyle}>
                        <li>Detect, prevent, and investigate fraudulent activity.</li>
                        <li>Monitor for security threats and unauthorized access.</li>
                        <li>Enforce our Terms of Service and prevent prohibited activities.</li>
                        <li>Protect the safety and integrity of the Platform.</li>
                    </ul>

                    <h4 style={subSectionTitleStyle}>5.6 Marketing and Communications (With Your Consent)</h4>
                    <ul style={listStyle}>
                        <li>Send promotional offers, newsletters, and service updates.</li>
                        <li>Provide personalized recommendations based on your booking history.</li>
                        <li>Conduct customer satisfaction surveys.</li>
                    </ul>
                    <p style={paragraphStyle}>
                        You may opt out of marketing communications at any time by using the unsubscribe link in emails or contacting <strong>info@washta.com</strong>. Opting out will not affect essential service-related communications.
                    </p>

                    <h4 style={subSectionTitleStyle}>5.7 Legal Compliance</h4>
                    <ul style={listStyle}>
                        <li>Comply with applicable laws, regulations, and legal processes.</li>
                        <li>Respond to requests from law enforcement or regulatory authorities.</li>
                        <li>Establish, exercise, or defend legal claims.</li>
                    </ul>

                    {/* ── 6. DATA SHARING AND DISCLOSURE ── */}
                    <h3 style={sectionTitleStyle}>6. Data Sharing and Disclosure</h3>
                    <p style={paragraphStyle}>We do <strong>NOT</strong> sell, rent, or trade your personal data. We may share your information only in the following limited circumstances:</p>

                    <h4 style={subSectionTitleStyle}>6.1 Service Providers (Independent Businesses)</h4>
                    <p style={paragraphStyle}>
                        Washta operates as an aggregator platform. When you book a service, we share booking-related information with the selected Service Provider:
                    </p>
                    <ul style={listStyle}>
                        <li>Your name, phone number, service location, vehicle details, and booking time.</li>
                        <li>Service Providers act as independent data controllers and are responsible for their own privacy practices during and after service delivery.</li>
                        <li>We do <strong>NOT</strong> share your email address, payment card details, or full booking history with Service Providers.</li>
                    </ul>
                    <div style={importantBoxStyle}>
                        <strong>Important:</strong> Service Providers must comply with our Partner Privacy Standards, which require use of customer data solely for service delivery, protection of customer information with appropriate security measures, and prohibition on selling or sharing customer data with third parties. However, Washta is not responsible for Service Providers' independent privacy practices outside the scope of Platform bookings.
                    </div>

                    <h4 style={subSectionTitleStyle}>6.2 Payment Processors</h4>
                    <p style={paragraphStyle}>We use certified third-party payment processors (PCI DSS compliant) to handle payment transactions. These processors receive:</p>
                    <ul style={listStyle}>
                        <li>Payment card information (entered directly on their secure payment pages).</li>
                        <li>Transaction amount and booking reference.</li>
                        <li>Customer name and email (for receipt purposes).</li>
                    </ul>
                    <p style={paragraphStyle}><strong>Current payment processor(s):</strong> Stripe.</p>

                    <h4 style={subSectionTitleStyle}>6.3 Technology and Infrastructure Providers</h4>
                    <p style={paragraphStyle}>We engage trusted service providers who assist in Platform operations:</p>
                    <ul style={listStyle}>
                        <li><strong>Cloud Hosting:</strong> Amazon Web Services, Google Cloud Platform — stores Platform data and infrastructure.</li>
                        <li><strong>Analytics Services:</strong> Google Analytics (anonymized usage data).</li>
                        <li><strong>Communication Services:</strong> SMS and email delivery providers (e.g., Twilio, SendGrid).</li>
                        <li><strong>Customer Support:</strong> Help desk software for managing support tickets.</li>
                    </ul>
                    <p style={paragraphStyle}>
                        These providers operate under strict data processing agreements and are contractually required to protect your data and use it only for the specified purposes.
                    </p>

                    <h4 style={subSectionTitleStyle}>6.4 Legal and Regulatory Authorities</h4>
                    <p style={paragraphStyle}>We may disclose personal data when required by law or to protect rights and safety:</p>
                    <ul style={listStyle}>
                        <li>In response to valid legal requests (court orders, subpoenas, warrants).</li>
                        <li>To comply with UAE tax, accounting, or regulatory obligations.</li>
                        <li>To investigate or prevent fraud, security threats, or illegal activity.</li>
                        <li>To protect the rights, property, or safety of Washta, users, or the public.</li>
                        <li>In connection with the enforcement of our Terms of Service.</li>
                    </ul>

                    <h4 style={subSectionTitleStyle}>6.5 Business Transfers</h4>
                    <p style={paragraphStyle}>
                        If Washta is involved in a merger, acquisition, asset sale, or bankruptcy, your personal data may be transferred to the successor entity. We will notify you of any such change in ownership or control of your personal data.
                    </p>

                    <h4 style={subSectionTitleStyle}>6.6 Aggregated and Anonymized Data</h4>
                    <p style={paragraphStyle}>
                        We may share aggregated, anonymized data that cannot identify you personally (e.g., market trends, usage statistics) with Service Providers, business partners, or the public. This data does not constitute personal data under UAE PDPL.
                    </p>

                    {/* ── 7. INTERNATIONAL DATA TRANSFERS ── */}
                    <h3 style={sectionTitleStyle}>7. International Data Transfers</h3>
                    <p style={paragraphStyle}>
                        Your personal data may be stored and processed on servers located outside the United Arab Emirates. When transferring personal data outside the UAE, we ensure adequate protection through:
                    </p>
                    <ul style={listStyle}>
                        <li><strong>Standard Contractual Clauses:</strong> Legally binding agreements with data recipients requiring UAE PDPL-equivalent protection.</li>
                        <li><strong>Adequacy Decisions:</strong> Transfers to jurisdictions recognized by the UAE as providing adequate data protection (if applicable).</li>
                        <li><strong>Vendor Certifications:</strong> Use of cloud providers with ISO 27001, SOC 2, or equivalent security certifications.</li>
                    </ul>
                    <p style={paragraphStyle}>
                        By using the Platform, you explicitly consent to the international transfer of your data as described. You may withdraw this consent at any time by contacting <strong>info@washta.com</strong>, though this may prevent us from providing services to you.
                    </p>

                    {/* ── 8. COOKIES AND TRACKING TECHNOLOGIES ── */}
                    <h3 style={sectionTitleStyle}>8. Cookies and Tracking Technologies</h3>
                    <p style={paragraphStyle}>We use cookies and similar tracking technologies to enhance your experience and analyze Platform usage.</p>

                    <h4 style={subSectionTitleStyle}>8.1 Types of Cookies We Use</h4>
                    <ul style={listStyle}>
                        <li><strong>Strictly Necessary:</strong> Login sessions, shopping cart, security. Duration: Session or until logout. Consent: Not required (essential).</li>
                        <li><strong>Performance &amp; Analytics:</strong> Usage patterns, error tracking (Google Analytics). Duration: Up to 24 months. Consent: Required.</li>
                        <li><strong>Functionality:</strong> Remember preferences (language, location). Duration: Up to 12 months. Consent: Required.</li>
                        <li><strong>Targeting/Advertising:</strong> Personalized ads, remarketing. Duration: Up to 12 months. Consent: Required.</li>
                    </ul>

                    <h4 style={subSectionTitleStyle}>8.2 Managing Cookie Preferences</h4>
                    <p style={paragraphStyle}>You can control cookies through:</p>
                    <ul style={listStyle}>
                        <li><strong>Cookie Consent Banner:</strong> Upon first visit, you will be prompted to accept or customize cookie preferences.</li>
                        <li><strong>Browser Settings:</strong> Most browsers allow you to block or delete cookies (see your browser's help menu).</li>
                        <li><strong>Google Analytics Opt-Out:</strong> Install the Google Analytics Opt-out Browser Add-on at https://tools.google.com/dlpage/gaoptout.</li>
                    </ul>
                    <p style={paragraphStyle}>
                        <strong>Note:</strong> Disabling strictly necessary cookies may impair Platform functionality (e.g., inability to log in or complete bookings).
                    </p>

                    {/* ── 9. DATA SECURITY ── */}
                    <h3 style={sectionTitleStyle}>9. Data Security</h3>
                    <p style={paragraphStyle}>We implement industry-standard technical and organizational measures to protect your personal data:</p>

                    <h4 style={subSectionTitleStyle}>9.1 Technical Safeguards</h4>
                    <ul style={listStyle}>
                        <li><strong>Encryption:</strong> All data transmitted to/from the Platform uses TLS/SSL encryption (HTTPS).</li>
                        <li><strong>Secure Hosting:</strong> Data stored on servers with firewalls, intrusion detection, and regular security updates.</li>
                        <li><strong>Payment Security:</strong> PCI DSS-compliant payment processing; we do not store full card details.</li>
                        <li><strong>Data Encryption at Rest:</strong> Sensitive data encrypted in databases.</li>
                    </ul>

                    <h4 style={subSectionTitleStyle}>9.2 Organizational Safeguards</h4>
                    <ul style={listStyle}>
                        <li><strong>Access Controls:</strong> Role-based access restrictions; only authorized personnel can access personal data.</li>
                        <li><strong>Employee Training:</strong> Regular data protection and security awareness training.</li>
                        <li><strong>Audit Logging:</strong> Monitoring and logging of data access for security review.</li>
                        <li><strong>Vendor Management:</strong> Third-party service providers bound by data processing agreements.</li>
                    </ul>

                    <h4 style={subSectionTitleStyle}>9.3 Data Breach Response</h4>
                    <p style={paragraphStyle}>In the event of a data breach that poses a risk to your rights:</p>
                    <ul style={listStyle}>
                        <li>We will notify the UAE Data Office within 72 hours of becoming aware of the breach, as required by UAE PDPL.</li>
                        <li>Affected users will be notified without undue delay if the breach poses a high risk to their rights and freedoms.</li>
                        <li>Notifications will include: the nature of the breach, likely consequences, and mitigation measures taken.</li>
                    </ul>

                    <h4 style={subSectionTitleStyle}>9.4 Limitations</h4>
                    <div style={importantBoxStyle}>
                        <strong>Important:</strong> While we employ robust security measures, no system is completely secure. Internet transmission and electronic storage carry inherent risks. We cannot guarantee absolute security but commit to maintaining commercially reasonable protections and promptly addressing any security incidents.
                    </div>

                    {/* ── 10. DATA RETENTION ── */}
                    <h3 style={sectionTitleStyle}>10. Data Retention</h3>
                    <p style={paragraphStyle}>We retain personal data only as long as necessary to fulfill the purposes outlined in this Privacy Policy or as required by law:</p>
                    <ul style={listStyle}>
                        <li><strong>Active Account Data:</strong> Duration of account + 3 years after closure. Reason: Service provision, legal claims.</li>
                        <li><strong>Booking and Transaction Records:</strong> 7 years from transaction date. Reason: UAE tax and accounting laws, audit requirements.</li>
                        <li><strong>Marketing Consent and Preferences:</strong> Until consent withdrawn + 30 days. Reason: Processing period for opt-out requests.</li>
                        <li><strong>Support Tickets and Communications:</strong> 3 years from resolution. Reason: Dispute resolution, quality improvement.</li>
                        <li><strong>Security Logs and Fraud Records:</strong> 6 years. Reason: Security investigations, legal claims.</li>
                        <li><strong>Analytics Data (Anonymized):</strong> Indefinitely. Reason: No personal data; used for business insights.</li>
                    </ul>
                    <p style={paragraphStyle}>
                        When you request deletion of your account (see Section 11), we will delete or anonymize your personal data in accordance with the above retention periods, except where retention is required by law.
                    </p>

                    {/* ── 11. YOUR RIGHTS UNDER UAE PDPL ── */}
                    <h3 style={sectionTitleStyle}>11. Your Rights Under UAE PDPL</h3>
                    <p style={paragraphStyle}>You have the following rights regarding your personal data:</p>

                    <h4 style={subSectionTitleStyle}>11.1 Right of Access</h4>
                    <p style={paragraphStyle}>You may request confirmation of whether we process your personal data and obtain a copy, including information about categories of data held, purposes of processing, recipients, and retention periods.</p>

                    <h4 style={subSectionTitleStyle}>11.2 Right to Rectification</h4>
                    <p style={paragraphStyle}>You may request correction of inaccurate or incomplete personal data. You can update most account information directly through the Platform settings.</p>

                    <h4 style={subSectionTitleStyle}>11.3 Right to Erasure ("Right to be Forgotten")</h4>
                    <p style={paragraphStyle}>You may request deletion of your personal data where:</p>
                    <ul style={listStyle}>
                        <li>The data is no longer necessary for the purposes for which it was collected.</li>
                        <li>You withdraw consent (where consent is the legal basis).</li>
                        <li>The data was processed unlawfully.</li>
                    </ul>
                    <p style={paragraphStyle}>
                        <strong>Limitations:</strong> We may retain certain data where required by law (e.g., transaction records for tax purposes) or for establishing, exercising, or defending legal claims.
                    </p>

                    <h4 style={subSectionTitleStyle}>11.4 Right to Restrict Processing</h4>
                    <p style={paragraphStyle}>You may request that we limit how we use your data (e.g., store but not process) while we verify accuracy or assess whether we have legitimate grounds for processing.</p>

                    <h4 style={subSectionTitleStyle}>11.5 Right to Data Portability</h4>
                    <p style={paragraphStyle}>You may request a copy of your data in a structured, commonly used, machine-readable format (e.g., CSV, JSON) and have the right to transmit this data to another service provider.</p>

                    <h4 style={subSectionTitleStyle}>11.6 Right to Object</h4>
                    <ul style={listStyle}>
                        <li><strong>Direct marketing:</strong> Opt out at any time via unsubscribe links or by contacting info@washta.com.</li>
                        <li><strong>Legitimate interests:</strong> We will cease processing unless we demonstrate compelling legitimate grounds that override your interests.</li>
                    </ul>

                    <h4 style={subSectionTitleStyle}>11.7 Right to Withdraw Consent</h4>
                    <p style={paragraphStyle}>Where processing is based on consent (e.g., marketing, location data), you may withdraw consent at any time. This does not affect the lawfulness of processing conducted before withdrawal.</p>

                    <h4 style={subSectionTitleStyle}>11.8 How to Exercise Your Rights</h4>
                    <p style={paragraphStyle}>To exercise any of the above rights:</p>
                    <ul style={listStyle}>
                        <li><strong>Email:</strong> info@washta.com</li>
                        <li><strong>Subject Line:</strong> "Data Subject Rights Request – [Your Name]"</li>
                        <li><strong>Include:</strong> Your full name, registered email/phone, description of your request, and proof of identity (for security).</li>
                    </ul>
                    <p style={paragraphStyle}>
                        <strong>Response Timeline:</strong> We will respond within 30 days of verifying your identity. If we need additional time, we will inform you of the reason and extension period (maximum 60 days total). Requests are generally free of charge. We may charge a reasonable fee for manifestly unfounded, excessive, or repetitive requests.
                    </p>

                    <h4 style={subSectionTitleStyle}>11.9 Right to Lodge a Complaint</h4>
                    <p style={paragraphStyle}>If you believe we have violated your data protection rights, you may lodge a complaint with:</p>
                    <ul style={listStyle}>
                        <li><strong>UAE Data Office:</strong> Contact details available from UAE authorities.</li>
                        <li><strong>Washta Data Protection Officer:</strong> info@washta.com — We encourage you to contact us first so we can address your concerns directly.</li>
                    </ul>

                    {/* ── 12. THIRD-PARTY LINKS AND SERVICES ── */}
                    <h3 style={sectionTitleStyle}>12. Third-Party Links and Services</h3>
                    <p style={paragraphStyle}>The Platform may contain links to third-party websites, applications, or services. Examples include:</p>
                    <ul style={listStyle}>
                        <li>Service Provider independent websites or booking systems.</li>
                        <li>Social media platforms.</li>
                        <li>Payment processor interfaces.</li>
                    </ul>
                    <div style={importantBoxStyle}>
                        <strong>Important:</strong> We are not responsible for the privacy practices, content, or security of these third-party sites. When you interact with Service Providers outside the Platform, their own privacy policies apply. We encourage you to review their policies before providing any personal information.
                    </div>

                    {/* ── 13. CHILDREN'S PRIVACY ── */}
                    <h3 style={sectionTitleStyle}>13. Children's Privacy</h3>
                    <p style={paragraphStyle}>
                        The Washta Platform is intended for users aged 18 years and older. We do not knowingly collect personal data from individuals under 18 years of age.
                    </p>
                    <p style={paragraphStyle}>
                        If you are a parent or guardian and believe your child under 18 has provided personal data to us, please contact <strong>info@washta.com</strong> immediately. We will delete such information promptly upon verification.
                    </p>

                    {/* ── 14. CHANGES TO THIS PRIVACY POLICY ── */}
                    <h3 style={sectionTitleStyle}>14. Changes to This Privacy Policy</h3>
                    <p style={paragraphStyle}>We may update this Privacy Policy periodically to reflect changes in our data processing practices, legal or regulatory requirements, or Platform features.</p>
                    <ul style={listStyle}>
                        <li><strong>Material changes:</strong> We will notify you via email or prominent in-app notice at least 30 days before changes take effect.</li>
                        <li><strong>Minor updates:</strong> We will update the "Last Updated" date at the top of this policy.</li>
                    </ul>
                    <p style={paragraphStyle}>
                        Your continued use of the Platform after changes become effective constitutes acceptance of the revised policy.
                    </p>

                    {/* ── 15. CONTACT INFORMATION ── */}
                    <h3 style={sectionTitleStyle}>15. Contact Information</h3>
                    <p style={paragraphStyle}>For questions, concerns, or requests related to this Privacy Policy or our data practices, please contact:</p>
                    <p style={paragraphStyle}>
                        <strong>Washta Data Protection Team</strong><br />
                        Email: <strong>info@washta.com</strong><br />
                        Data Protection Officer: <strong>info@washta.com</strong><br />
                        General Inquiries: <strong>info@washta.com</strong>
                    </p>

                    {/* Footer Note */}
                    <div style={{ textAlign: 'center', marginTop: '60px', borderTop: '1px solid #ddd', paddingTop: '30px' }}>
                        <p style={{ ...paragraphStyle, textAlign: 'center', fontWeight: 'bold', color: '#333' }}>
                            Thank you for trusting Washta with your personal information. We are committed to protecting your privacy and using your data responsibly.
                        </p>
                        {/* <p style={{ ...paragraphStyle, textAlign: 'center', color: '#aaa', fontSize: '14px', marginTop: '10px' }}>
                            © 2026 SNR LLC. All Rights Reserved.
                        </p> */}
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
}

export default PrivPolicy;